export default "__VITE_ASSET__DRBTX1pg__"